import { OpinionScope } from '../../opinions/store/types';

export enum SubCounterpartyActionTypes {
    FETCH_OPINION_SUB_COUNTERPARTY_TYPES_STARTED = 'FETCH_OPINION_SUB_COUNTERPARTY_TYPES_STARTED',
    FETCH_OPINION_SUB_COUNTERPARTY_TYPES_SUCCESSFUL = 'FETCH_OPINION_SUB_COUNTERPARTY_TYPES_SUCCESSFUL',
    FETCH_OPINION_SUB_COUNTERPARTY_TYPES_FAILED = 'FETCH_OPINION_SUB_COUNTERPARTY_TYPES_FAILED',
    UPSERT_OPINION_SUB_COUNTERPARTY_TYPES_STARTED = 'UPSERT_OPINION_SUB_COUNTERPARTY_TYPES_STARTED',
    UPSERT_OPINION_SUB_COUNTERPARTY_TYPES_SUCCESSFUL = 'UPSERT_OPINION_SUB_COUNTERPARTY_TYPES_SUCCESSFUL',
    UPSERT_OPINION_SUB_COUNTERPARTY_TYPES_FAILED = 'UPSERT_OPINION_SUB_COUNTERPARTY_TYPES_FAILED',
    UPDATE_OPINION_SUB_COUNTERPARTY_VALUE = 'UPDATE_OPINION_SUB_COUNTERPARTY_VALUE',
    SET_SELECTED_OPINION_SUB_COUNTERPARTY = 'SET_SELECTED_OPINION_SUB_COUNTERPARTY',
    SET_SUB_COUNTERPARTY_JURISDICTION = 'SET_SUB_COUNTERPARTY_JURISDICTION',
    SET_SUB_COUNTERPARTY_PARENT = 'SET_SUB_COUNTERPARTY_PARENT',
    RESET_AVAILABLE_SUB_COUNTERPARTY_TYPES = 'RESET_AVAILABLE_SUB_COUNTERPARTY_TYPES',
    SET_JURISDICTION_SUB_COUNTERPARTY_TYPES = 'SET_JURISDICTION_SUB_COUNTERPARTY_TYPES',
    ADD_OPINION_SUB_COUNTERPARTY_TYPE = 'ADD_OPINION_SUB_COUNTERPARTY_TYPE',
    REVERT_SELECTED_SUB_COUNTERPARTY_CHANGES = 'REVERT_SELECTED_SUB_COUNTERPARTY_CHANGES',
    UPDATE_MULTI_PARENT_COUNTERPARTIES = 'UPDATE_MULTI_PARENT_COUNTERPARTIES',
    SET_SAVED_MULTI_PARENT_COUNTERPARTIES = 'SET_SAVED_MULTI_PARENT_COUNTERPARTIES',
    UPDATE_DELETE_OPINION_SUB_COUNTERPARTY_TYPES = 'UPDATE_DELETE_OPINION_SUB_COUNTERPARTY_TYPES',
    DELETE_OPINION_SUB_COUNTERPARTY_TYPES_STARTED = 'DELETE_OPINION_SUB_COUNTERPARTY_TYPES_STARTED',
    DELETE_OPINION_SUB_COUNTERPARTY_TYPES_SUCCESSFUL = 'DELETE_OPINION_SUB_COUNTERPARTY_TYPES_SUCCESSFUL',
    DELETE_OPINION_SUB_COUNTERPARTY_TYPES_FAILED = 'DELETE_OPINION_SUB_COUNTERPARTY_TYPES_FAILED',
    SET_OPINION_SUB_COUNTERPARTY_SCOPE_FILTERS = 'SET_OPINION_SUB_COUNTERPARTY_SCOPE_FILTERS'
}

export interface SubCounterpartyType {
    subCounterpartyTypeId?: number;
    subCounterpartyName: string;
    subCounterpartyDescription: string | null;
    jurisdiction: string;
    parentCounterpartyType: string;
    scopes: OpinionScope[];
    isSystem: number;
    isIncludedInOpinion?: boolean;
}

export interface SubCounterpartyTypeDB extends SubCounterpartyType {
    createdBy: number;
    createdDate: string;
    clientId: number;
}

export interface SubCounterpartyState {
    availableOpinionSubCounterpartyTypes: SubCounterpartyType[];
    jurisdictionalOpinionSubCounterpartyTypes: SubCounterpartyType[];
    selectedSubCounterparty: SubCounterpartyType | null;
    savedSelectedSubCounterparty: SubCounterpartyType | null;
    isEditing: boolean;
    jurisdiction: string | null;
    parentCounterparty: string | null;
    isFetching: boolean;
    multiParentCounterparties: string[];
    savedParentCounterparties: string[];
    subCounterpartyTypesToDelete: SubCounterpartyType[] | null;
    isDeleting: boolean;
    scopeFilters: OpinionScope[];
}
